<template>
    <div class="cascader">
        <span class="fs-14" ref="span">
            {{ title }}
            <i class="el-icon-caret-bottom"/>
        </span>
        <el-cascader
            ref="cascader"
            v-bind="$attrs"
            v-on="$listeners"/>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '所有分组'
        }
    },

    mounted() {
        const { span, cascader } = this.$refs
        const cascaderEl = cascader.$el
        const spanOffset = span.getBoundingClientRect()
        cascaderEl.style.width = spanOffset.width + 'px'
        cascaderEl.style.height = spanOffset.height + 'px'
    }
}
</script>

<style lang="scss" scoped>
.cascader {
    position: relative;
    display: inline-block;
}

::v-deep .el-cascader {
    position: absolute;
    left: 0;
    top: -4px;
    transform: scale(1, 0.7);
    opacity: 0;
}
</style>
